import TextSegmentSink from "./text_segment_sink";
export default TextSegmentSink;
